import * as _htmlDomParser2 from "html-dom-parser";
var _htmlDomParser = _htmlDomParser2;
try {
  if ("default" in _htmlDomParser2) _htmlDomParser = _htmlDomParser2.default;
} catch (e) {}
import _attributesToProps from "./attributes-to-props";
import _domToReact from "./dom-to-react";
import * as _domhandler2 from "domhandler";
var _domhandler = _domhandler2;
try {
  if ("default" in _domhandler2) _domhandler = _domhandler2.default;
} catch (e) {}
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlToDOM = exports.domToReact = exports.attributesToProps = exports.Text = exports.ProcessingInstruction = exports.Element = exports.Comment = void 0;
exports.default = HTMLReactParser;
var html_dom_parser_1 = __importDefault(_htmlDomParser);
exports.htmlToDOM = html_dom_parser_1.default;
var attributes_to_props_1 = __importDefault(_attributesToProps);
exports.attributesToProps = attributes_to_props_1.default;
var dom_to_react_1 = __importDefault(_domToReact);
exports.domToReact = dom_to_react_1.default;
var domhandler_1 = _domhandler;
Object.defineProperty(exports, "Comment", {
  enumerable: true,
  get: function () {
    return domhandler_1.Comment;
  }
});
Object.defineProperty(exports, "Element", {
  enumerable: true,
  get: function () {
    return domhandler_1.Element;
  }
});
Object.defineProperty(exports, "ProcessingInstruction", {
  enumerable: true,
  get: function () {
    return domhandler_1.ProcessingInstruction;
  }
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function () {
    return domhandler_1.Text;
  }
});
var domParserOptions = {
  lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param html - HTML string.
 * @param options - Parser options.
 * @returns - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== "string") {
    throw new TypeError("First argument must be a string");
  }
  if (!html) {
    return [];
  }
  return (0, dom_to_react_1.default)((0, html_dom_parser_1.default)(html, (options === null || options === void 0 ? void 0 : options.htmlparser2) || domParserOptions), options);
}
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  htmlToDOM = exports.htmlToDOM,
  domToReact = exports.domToReact,
  attributesToProps = exports.attributesToProps,
  Text = exports.Text,
  ProcessingInstruction = exports.ProcessingInstruction,
  Element = exports.Element,
  Comment = exports.Comment;